//时间戳 xxxx.xx.xx xx:xx 时间格式：20200820175002
let formatTime = (time = '') => {
  const Year = time.slice(0, 4);
  const Month = time.slice(4, 6);
  const Day = time.slice(6, 8);
  const hour = time.slice(8, 10);
  const fen = time.slice(10, 12);
  return time = `${Year}.${Month}.${Day} ${hour}:${fen}`;
}
//时间戳转换  xxxx-xx-xx xx:xx  时间格式：时间戳163090909090904
let formatTime1 = (time = '') => {
  let date=new Date(time);
  let Year=date.getFullYear();
  let Month=(date.getMonth()+1)<10?"0"+(date.getMonth()+1):date.getMonth()+1;
  let Day=date.getDate()<10?"0"+date.getDate():date.getDate();
  let hour=date.getHours();
  let fen=date.getMinutes();
  return `${Year}-${Month}-${Day} ${hour}:${fen}`;
}
//时间戳 xxxx.xx.xx 时间格式：20200820175002
let formatTime2 = (time = '') => {
  const Year = time.slice(0, 4);
  const Month = time.slice(4, 6);
  const Day = time.slice(6, 8);
  return time = `${Year}.${Month}.${Day}`;
}
export default {
  formatTime,
  formatTime1,
  formatTime2
}


// WEBPACK FOOTER //
// ./src/util/filter.js